import React from "react";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import { NavLink } from "react-router-dom";

import { BasicResourceType } from "../../../../types/resources/resources.enums";
import { IUser } from "../../../../types/user/iuser.interface";
import { formatDate } from "../../../../utils/date-format.utils";
import { getResourceLink } from "../../../../features/navigation/types/pages.functions";
import { getUserFullName } from "../../../../features/user/types/user.functions";

import { flyerStatus } from "../../types/flyer-list-table/flyer-list-table.functions";

import { FlyerListGridCardProps } from "./flyer-list-grid-card.props";
import { useFlyerListGridCardStyles } from "./flyer-list-grid-card.styles";

export const FlyerListGridCard = ({ flyer }: FlyerListGridCardProps) => {
  const classes = useFlyerListGridCardStyles();

  const format = "MMM D";
  const subHeader = `${formatDate(flyer.startAt, format)} - ${formatDate(flyer.endAt, format)}`;

  return (
    <Card
      className={classes.card}
      // @ts-ignore
      component={NavLink}
      to={getResourceLink(flyer.id, BasicResourceType.Flyer)}
    >
      <CardHeader title={flyer.name} subheader={subHeader} />
      <CardContent>
        Owner: {getUserFullName(flyer.owner as IUser)}
        <br />
        Pages: {flyer.pageCount}
        <br />
        Positions: {flyer.positionCount}
        <br />
        Status: {flyerStatus(flyer.paginationStatus)}
      </CardContent>
    </Card>
  );
};
